/* istanbul ignore file */

import styled from 'styled-components';
import { fonts, colors, medias } from 'assets/styled/tokens';
import { Checkbox } from 'components/Form/subcomponents/Checkbox';
import { Tooltip } from 'components/Tooltip';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';

export const StyledWelcome = styled.div`
  width: 100%;
  margin-bottom: 32px;

  h3 {
    font-weight: 700;
    font-size: 24px;
    color: ${colors.carbon};
    font-family: ${fonts.family.title};
    line-height: 20px;
    margin-bottom: 8px;
  }

  span {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 410px;
  max-width: 90vw;

  img {
    max-width: 201px;
    margin: 0 auto 54px 0;
  }

  button {
    width: 100%;
    font-size: 13px;
  }
`;
export const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 16px;
`;
export const StyledFormLogin = styled.div`
  display: block;
  width: 100%;
  min-width: 295px;

  > div {
    margin-bottom: 16px;
  }

  input {
    margin-bottom: 3px;
  }
`;

export const StyledStayConnectedCheckbox = styled(Checkbox)`
  width: auto;
  cursor: pointer;
  margin-right: 5px;
`;
export const StyledTooltip = styled(Tooltip)`
  margin-right: auto;
`;
export const StyledFormFooter = styled.div`
  display: flex;
  margin-top: 32px;
  #loginButton {
    max-width: 127px;
    width: 20vw;
  }
  button {
    margin-left: auto;
    width: 127px;
    height: 40px;
  }
`;

export const StyledForgetPasswordLink = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 0;
  top: -2px;

  a {
    font-weight: 500;
    font-size: 13px;
    line-height: 15px;
    text-decoration-line: underline;
    color: ${colors.gray};
  }
`;

export const StyledError = styled.div`
  display: block;
  margin-top: -10px;
  font-size: 12px;

  p {
    font-family: ${fonts.family.text};
    color: ${colors.cinnabar};
  }
`;
export const StyledModalBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: 21px;

  img {
    max-width: 80px;
    margin-bottom: 10px;
  }

  h6 {
    font-family: ${fonts.family.title};
    color: ${colors.bittersweet};
    font-weight: 700;
    font-size: 21px;
    line-height: 25.2px;
    margin-bottom: 10px;
    text-align: center;
  }

  p,
  span {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 18.75px;
    margin-top: 0;
    margin-bottom: 40px;
    text-align: center;
    color: ${colors.gray};

    a {
      color: ${colors.primary};
      font-weight: bold;
    }
  }

  button:first-child {
    width: 85px;
    height: 32px;
  }

  @media screen and (min-width: ${medias.tablet}) {
    padding-right: 10px;
    padding-left: 10px;
  }
`;
export const StyledModalButton = styled.div`
  display: flex;
`;

export const StyledP = styled.div`
  margin-bottom: 40px;
  margin-top: -40px;
`;

export const Linha = styled.div`
  flex: 1;
  height: 1px;
  background-color: #cccccc;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
`;

export const Texto = styled.span`
  margin: 0 10px;
  color: #888888;
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
`;
export const SSOLoginButton = styled.button`
  border: 1px solid #f38a00;
  border-radius: 4px;
  width: 100%;
  height: 40px;
  background-color: #fff;
  color: #f38a00;
  font-family: Roboto;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  text-align: center;
`;
